import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;

  @media screen and (max-width: 767px) {
    padding: 20px;
  }
`;

export const Title = styled.div`
  font-family: Poppins-Regular;
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  color: #4F4F4F;
`;

export const SubTitle = styled.div`
  font-family: Poppins-Regular;
  font-weight: 500;
  font-size: 14px;
  line-height: 27px;
  color: #4F4F4F;
  margin-top: 10px;
`;

export const ModalForm = styled.div`
  width: 100%;
  margin-top: 10px;
`;

export const BackBtn = styled.div`
  border: 2px solid #D40020;
  box-sizing: border-box;
  border-radius: 500px;
  color: #D40020;
  padding: 10px;
  width: auto;
  cursor: pointer;
  font-family: Poppins-Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  width: 100%;

  &:hover {
    opacity: 0.6;
  }

  &[disabled] {
    pointer-events: none;
    opacity: 0.8;
  }
`;

export const SubmitBtn = styled.div`
  background: #D40020;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  border-radius: 500px;
  padding: 10px;
  width: auto;
  cursor pointer;
  color: #fff;
  font-family: Poppins-Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 200px;
  width: 100%;

  &:hover {
    opacity: 0.6;
  }

  &[disabled] {
    pointer-events: none;
    opacity: 0.8;
  }

  @media screen and (max-width: 767px) {
    margin-top: 10px;
  }
`;

export const ActionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 40px;
  width: 30%;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    margin-top: 5px;
  }
`;

export const FakeBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: #4F4F4F;
  opacity: 0.6;
`;

export const Select = styled.select`
  font-family: Poppins-Regular;
  font-size: 16px;
  line-height: 21px;
  color: #4F4F4F;
  border: 0;
  outline: 0px;
  border-bottom: 1px solid #B1B1B1;
  box-sizing: border-box;
  padding: 10px 0px 5px 0px;
`;

export const SelectState = styled.select`
  font-family: Poppins-Regular;
  font-size: 16px;
  line-height: 21px;
  color: #4F4F4F;
  border: 0;
  outline: 0px;
  border-bottom: 1px solid #B1B1B1;
  box-sizing: border-box;
  padding: 5px 0px 5px 0px;
`;